import React, { Component } from 'react';
import Swal from "sweetalert2";
import { Spinner, Modal, Dropdown, Table, Badge, Button, ButtonGroup } from "react-bootstrap";

import moment from 'moment';
import Footer from "../components/Footer";
import Sidebar from '../components/Sidebar';
import { withSidebar } from "../context/SidebarContext";
import { NumericFormat as NumberFormat } from 'react-number-format';
import logo from "../assets/images/logo.png";


const baseUrl = process.env.REACT_APP_BASE_URL


class Payments extends Component {

  constructor(props){
    super(props);
    this.state = {
      data: [],
      printPaymentDetails: [],
      postsPerPage: 10,
      currentPage: 1,
      totalPages: 0,
      totalItems: 0,
      loading: true,
      isLoading: false,
      noRecords: false,
      isVerifiedLoading: false,
      isPrintLoading: false,
      // Filter states
      filterStatus: "",
      filterKeyword: "",
      filterStartDate: "",
      filterEndDate: "",
      isDownloading: {},
      // Modal visibility states
      showPrintModal: false,
    }
  }
  print(){
    window.print()
  }

  // Download PDF receipt or pay advice
  downloadPdf = async (paymentId, rrr) => {
    this.setState(prevState => ({
      isDownloading: { ...prevState.isDownloading, [paymentId]: true }
    }));

    try {
      const response = await fetch(`${baseUrl}/v2/user/payments/${paymentId}/pdf`, {
        method: 'GET',
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (response.status === 401) {
        Swal.fire({
          title: "Session Expired",
          text: "Session expired. Please login",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          this.props.history.push("/login");
        });
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `payment_${rrr || paymentId}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "Failed to download PDF",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      this.setState(prevState => ({
        isDownloading: { ...prevState.isDownloading, [paymentId]: false }
      }));
    }
  }

  // Get status badge styling
  getStatusBadge = (status, message) => {
    const statusLower = (status || message || '').toLowerCase();

    // Completed payment
    if (statusLower === 'complete' || statusLower === 'successful' || statusLower === '00') {
      return { className: 'badge bg-success', text: 'Completed' };
    }

    // User has NOT paid yet (Remita code 021 = Transaction Pending)
    if (statusLower === '021' || statusLower === 'pending_payment' || statusLower === 'payment initialized') {
      return { className: 'badge bg-danger', text: 'Not Paid' };
    }

    // User HAS paid, awaiting bank confirmation (Remita codes 045, 058, 070, 071, 072)
    if (statusLower === 'pending_confirmation' ||
        statusLower === '045' || statusLower === '058' ||
        statusLower === '070' || statusLower === '071' || statusLower === '072') {
      return { className: 'badge bg-info text-white', text: 'Processing' };
    }

    // Failed payment
    if (statusLower === 'failed' || statusLower === '99') {
      return { className: 'badge bg-danger', text: 'Failed' };
    }

    // Other pending states
    if (statusLower.includes('pending') || statusLower.includes('initialized')) {
      return { className: 'badge bg-warning text-dark', text: 'Pending' };
    }

    return { className: 'badge bg-secondary', text: status || message || 'Unknown' };
  }

  // Handle filter changes
  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  // Apply filters
  applyFilters = () => {
    this.setState({ currentPage: 1 }, () => {
      this.retrievePayments();
    });
  }

  // Clear filters
  clearFilters = () => {
    this.setState({
      filterStatus: "",
      filterKeyword: "",
      filterStartDate: "",
      filterEndDate: "",
      currentPage: 1,
    }, () => {
      this.retrievePayments();
    });
  }

  checkPaymentStatus = async(rrr) =>{
    this.setState({isVerifiedLoading: true});
    const url = `${baseUrl}/v2/remita/checkRRRStatus/${rrr}`;
     fetch(url, {
      method: 'PUT',
      headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(res => res.json())
      .then(res => {
        this.setState({isVerifiedLoading: false});

        // Determine icon based on payment status
        const icon = res.paymentStatus === 'complete' ? 'success' :
                     res.paymentStatus === 'failed' ? 'error' : 'info';

        Swal.fire({
        title: '<strong>PAYMENT STATUS</strong>',
        icon: icon,
        html:
          '<b>RRR:</b> ' + res.RRR + '<br/><br/>'+
          '<b>AMOUNT:</b> ₦' + Math.round(res.amount).toLocaleString() + '<br/><br/>'+
          '<b>STATUS:</b> ' + (res.remitaMessage || res.message) + '<br/><br/>'+
          (res.transactiontime ? '<b>DATE:</b> ' + res.transactiontime : ''),
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: 'OK'
      }).then(() => {
          // Refresh the payments table after closing the popup
          this.retrievePayments();
        });
      })
      .catch(error => {
        this.setState({isVerifiedLoading: false});
        Swal.fire({
          title: 'Error',
          text: 'Failed to verify payment status. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      });
  }

  printPaymentDetails = async (recid) => {
    this.setState({isPrintLoading: true});


    let req = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    await fetch(`${baseUrl}/Payments/getPaymentsByRecID/${recid}`, req)
      .then((response) => response.json())
      .then((responseJson) => {
        // console.warn(responseJson);
        this.setState({printPaymentDetails: responseJson, isPrintLoading: false});


      })
      .catch((error) => {
        this.setState({ isPrintLoading: false, disabled: false });
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
    }

    // Handle Pay Now - directly trigger Remita Payment Engine
    handleOpenPayModal = async (item) => {
      const rrr = item.rrr;

      if (!rrr) {
        Swal.fire({
          title: "Error",
          text: "No RRR found for this payment.",
          icon: "error",
        });
        return;
      }

      this.setState({ isLoading: true });

      try {
        const url = `${baseUrl}/v2/remita/checkRRRStatus/${rrr}`;
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status === 401) {
          Swal.fire({
            title: "Session Expired",
            text: "Session expired. Please login",
            icon: "error",
            confirmButtonText: "OK",
          }).then(() => {
            this.props.history.push("/login");
          });
          return;
        }

        const statusCheckResponse = await response.json();

        if (!statusCheckResponse || statusCheckResponse.isSuccessful === false) {
          Swal.fire({
            title: "Error",
            text: statusCheckResponse?.message ?? "Unable to contact Remita. Please try again.",
            icon: "error",
          });
          return;
        }

        switch (statusCheckResponse.paymentStatus) {
          case "complete":
            Swal.fire({ title: "Success", text: "Payment already completed!", icon: "success" });
            this.retrievePayments();
            break;
          case "pending_confirmation":
            Swal.fire({ title: "Info", text: "Payment is being confirmed.", icon: "info" });
            break;
          case "failed":
            Swal.fire({ title: "Error", text: "Payment failed: " + statusCheckResponse.remitaMessage, icon: "error" });
            break;
          default:
            // Open Remita payment iframe
            var paymentEngine = window.RmPaymentEngine.init({
              key: process.env.REACT_APP_REMITA_KEY,
              processRrr: true,
              transactionId: Date.now().toString(),
              extendedData: {
                customFields: [{ name: "rrr", value: statusCheckResponse.RRR }],
              },
              onSuccess: () => {
                this.retrievePayments();
                window.location.reload();
              },
              onError: (error) => console.error(error),
              onClose: () => {},
            });
            paymentEngine.openIframe();
        }
      } catch (error) {
        Swal.fire({ title: "Error", text: "Failed to initialize payment.", icon: "error" });
      } finally {
        this.setState({ isLoading: false });
      }
    };

    handleOpenPrintModal = (recid) => {
      this.printPaymentDetails(recid);
      this.setState({ showPrintModal: true });
    };

    handleClosePrintModal = () => {
      this.setState({ showPrintModal: false });
    };

  showPagination = () => {
    const { totalPages, currentPage } = this.state;
    const pageNumbers = [];

    // Create page numbers array
    for(let i = 1; i <= totalPages; i++){
      pageNumbers.push(i)
    }

    const paginate = (pageNumber) => {
      this.setState({ currentPage: pageNumber }, () => {
        this.retrievePayments();
      });
    }

    if (totalPages <= 1) return null;

    return(
      <nav>
        <ul className="pagination">
          <li className={currentPage === 1 ? 'page-item disabled' : 'page-item'}>
            <button onClick={() => paginate(currentPage - 1)} className="page-link" disabled={currentPage === 1}>
              Previous
            </button>
          </li>
          {pageNumbers.map(number => (
            <li key={number} className={currentPage === number ? 'page-item active' : 'page-item'}>
              <button onClick={() => paginate(number)} className="page-link">
                {number}
              </button>
            </li>
          ))}
          <li className={currentPage === totalPages ? 'page-item disabled' : 'page-item'}>
            <button onClick={() => paginate(currentPage + 1)} className="page-link" disabled={currentPage === totalPages}>
              Next
            </button>
          </li>
        </ul>
      </nav>
    )
  }

  // Get Bootstrap Badge variant from status
  getStatusVariant = (status, message) => {
    const statusLower = (status || message || '').toLowerCase();

    if (statusLower === 'complete' || statusLower === 'successful' || statusLower === '00') {
      return 'success';
    }
    if (statusLower === '021' || statusLower === 'pending_payment' || statusLower === 'payment initialized') {
      return 'danger';
    }
    if (statusLower === 'pending_confirmation' || statusLower === '045' || statusLower === '058' ||
        statusLower === '070' || statusLower === '071' || statusLower === '072') {
      return 'info';
    }
    if (statusLower === 'failed' || statusLower === '99') {
      return 'danger';
    }
    if (statusLower.includes('pending') || statusLower.includes('initialized')) {
      return 'warning';
    }
    return 'secondary';
  }

  renderTableRows = () => {
    const { postsPerPage, currentPage, data, isDownloading } = this.state;

    return data.map((item, index) => {
      const statusBadge = this.getStatusBadge(item.status, item.message);
      const statusVariant = this.getStatusVariant(item.status, item.message);
      const isItemDownloading = isDownloading[item.recId || item.recid];
      const paymentDate = moment(item.paymentDate || item.paymentdate);
      const formattedDate = paymentDate.isValid() ? paymentDate.format('LL') : '-';

      return (
        <tr key={item.recId || item.recid || index}>
          <td className="text-center align-middle">
            <span className="fw-bold">{postsPerPage * (currentPage - 1) + index + 1}</span>
          </td>
          <td className="align-middle">
            <code className="text-dark">{item.rrr}</code>
          </td>
          <td className="align-middle text-wrap" style={{ maxWidth: '250px' }}>
            {item.description}
          </td>
          <td className="align-middle fw-bold">
            <NumberFormat
              value={item.amount || item.amountDecimal}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={0}
              prefix="₦"
              renderText={value => <span>{value}</span>}
            />
          </td>
          <td className="align-middle">
            <Badge bg={statusVariant} className="px-3 py-2">
              {statusBadge.text}
            </Badge>
          </td>
          <td className="align-middle text-muted">
            {formattedDate}
          </td>
          <td className="align-middle text-center">
            <Dropdown align="end">
              <Dropdown.Toggle
                as={Button}
                variant="light"
                size="sm"
                className="border-0 bg-transparent p-1"
                id={`dropdown-${item.recId || item.recid}`}
              >
                <span style={{ fontSize: '18px', color: '#6c757d' }}>⋮</span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="shadow-sm">
                {!item.isComplete && (
                  <Dropdown.Item
                    onClick={() => this.handleOpenPayModal(item)}
                    className="py-2"
                  >
                    <span className="me-2">💳</span> Pay Now
                  </Dropdown.Item>
                )}

                <Dropdown.Item
                  onClick={() => this.checkPaymentStatus(item.rrr)}
                  className="py-2"
                >
                  <span className="me-2">🔄</span> Verify Status
                </Dropdown.Item>

                <Dropdown.Divider />

                <Dropdown.Item
                  onClick={() => this.downloadPdf(item.recId || item.recid, item.rrr)}
                  className="py-2"
                  disabled={isItemDownloading}
                >
                  {isItemDownloading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <span className="me-2">📄</span> Download {item.isComplete ? 'Receipt' : 'Pay Advice'}
                    </>
                  )}
                </Dropdown.Item>

                <Dropdown.Item
                  onClick={() => this.handleOpenPrintModal(item.recId || item.recid)}
                  className="py-2"
                >
                  <span className="me-2">👁</span> View Details
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </td>
        </tr>
      );
    });
  };


  retrievePayments = async () => {
    const { currentPage, postsPerPage, filterStatus, filterKeyword, filterStartDate, filterEndDate } = this.state;
    this.setState({ loading: true });

    // Build query params
    const params = new URLSearchParams();
    params.append('page', currentPage - 1); // API uses 0-based pagination
    params.append('size', postsPerPage);

    if (filterStatus) params.append('status', filterStatus);
    if (filterKeyword) params.append('keyword', filterKeyword);
    if (filterStartDate) params.append('startDate', new Date(filterStartDate).toISOString());
    if (filterEndDate) params.append('endDate', new Date(filterEndDate).toISOString());

    let obj = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };

    try {
      const response = await fetch(`${baseUrl}/v2/user/payments?${params.toString()}`, obj);

      // Fallback to legacy API if v2 endpoint is not available (404)
      if (response.status === 404) {
        this.retrievePaymentsLegacy();
        return;
      }

      if (response.status === 401) {
        this.setState({ loading: false });
        Swal.fire({
          title: "Session Expired",
          text: "Session expired. Please login",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          this.props.history.push("/login");
        });
        return;
      }

      const responseJson = await response.json();

      if (responseJson.content && responseJson.content.length === 0) {
        this.setState({
          noRecords: true,
          loading: false,
          data: [],
          totalPages: 0,
          totalItems: 0
        });
      } else {
        this.setState({
          data: responseJson.content || [],
          totalPages: responseJson.totalPages || 0,
          totalItems: responseJson.totalItems || 0,
          currentPage: (responseJson.currentPage || 0) + 1, // Convert back to 1-based
          noRecords: false,
          loading: false
        });
      }
    } catch (error) {
      this.setState({ loading: false });
      // Fallback to old API if v2 is not available
      this.retrievePaymentsLegacy();
    }
  }

  // Fallback to old API
  retrievePaymentsLegacy = async () => {
    let obj = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await fetch(`${baseUrl}/Payments/getPaymentsByUserID/${localStorage.getItem("userid")}`, obj)
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status === 401) {
            this.setState({ loading: false });
            Swal.fire({
              title: "Session Expired",
              text: "Session expired. Please login",
              icon: "error",
              confirmButtonText: "OK",
            }).then(() => {
              this.props.history.push("/login");
            });
          } else if(responseJson.length <= 0){
            this.setState({ noRecords: true, loading: false})
          } else {
            const sortedData = responseJson.sort((a, b) => {
              return new Date(b.paymentdate) - new Date(a.paymentdate);
            });
            this.setState({
              data: sortedData,
              totalPages: Math.ceil(sortedData.length / this.state.postsPerPage),
              totalItems: sortedData.length,
              loading: false
            })
          }
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  }

  componentDidMount(){
    this.retrievePayments();
  }

  render(){
    const { noRecords, isPrintLoading, printPaymentDetails, loading, totalItems, filterStatus, filterKeyword, filterStartDate, filterEndDate } = this.state;

    return(
      <div className="g-sidenav-show">
      <Sidebar />
      <div className="container border-bottom">
        <div className="d-flex justify-content-between">
          <div
            onClick={() => this.props.sidebar.toggle()}
            className="text-center me-2 d-flex align-items-center justify-content-center bg-dark w-15 rounded-circle"
            id="dash-menu"
            style={{ height: "50px" }}
          >
            <i className="material-icons text-center opacity-10 text-light w-20">menu</i>
          </div>
        </div>
      </div>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg " style={{width: '80%', float: 'right'}}>


      <div className="container-fluid justify-content-center py-4" style={{ width: '100%', position: 'relative', left: 0 }}>

      <div className="text-dark text-bold">
        <h4 style={{ marginTop: 27 }}>Payments History</h4>
      </div>

      <div className="container-fluid px-4">
        <div className="rown">
          <div className="col-12">
            <div className="card my-3">
              <div className="card-header pb-0 bg-success">
                <div className="d-flex flex-wrap align-items-center justify-content-between">
                  <h5 className="mb-4 text-light font-weight-bold">
                    {this.state.isVerifiedLoading ? (
                      <center><h5 className="text-light">Verifying Payment ... </h5><Spinner animation="border" className="text-center" variant="light" size="lg" /></center>
                    ) : (
                      <>My Payment History {totalItems > 0 && <span className="badge bg-light text-dark ms-2">{totalItems}</span>}</>
                    )}
                  </h5>
                </div>
              </div>
              <div className="card-body">

              {/* Filter Section */}
              <div className="row mb-4 p-3 bg-light rounded">
                <div className="col-md-3 mb-2">
                  <label className="form-label text-xs font-weight-bold">Search</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search RRR or description..."
                    name="filterKeyword"
                    value={filterKeyword}
                    onChange={this.handleFilterChange}
                  />
                </div>
                <div className="col-md-2 mb-2">
                  <label className="form-label text-xs font-weight-bold">Status</label>
                  <select
                    className="form-select form-select-sm"
                    name="filterStatus"
                    value={filterStatus}
                    onChange={this.handleFilterChange}
                  >
                    <option value="">All Status</option>
                    <option value="complete">Completed</option>
                    <option value="pending">Pending</option>
                    <option value="failed">Failed</option>
                  </select>
                </div>
                <div className="col-md-2 mb-2">
                  <label className="form-label text-xs font-weight-bold">From Date</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="filterStartDate"
                    value={filterStartDate}
                    onChange={this.handleFilterChange}
                  />
                </div>
                <div className="col-md-2 mb-2">
                  <label className="form-label text-xs font-weight-bold">To Date</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="filterEndDate"
                    value={filterEndDate}
                    onChange={this.handleFilterChange}
                  />
                </div>
                <div className="col-md-3 mb-2 d-flex align-items-end">
                  <button
                    className="btn btn-success btn-sm me-2"
                    onClick={this.applyFilters}
                  >
                    <span className="iconify me-1" data-icon="mdi:filter"></span>
                    Filter
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={this.clearFilters}
                  >
                    Clear
                  </button>
                </div>
              </div>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="success" />
            <p className="mt-2 text-muted">Loading payments...</p>
          </div>
        ) : noRecords ? (
          <div className="text-center py-5">
            <p className="text-muted">No payment records found.</p>
          </div>
        ) : (
          <div className="table-responsive">
            <Table hover className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center" style={{ width: '60px' }}>S/N</th>
                  <th>RRR</th>
                  <th>Description</th>
                  <th style={{ width: '130px' }}>Amount</th>
                  <th style={{ width: '120px' }}>Status</th>
                  <th style={{ width: '150px' }}>Date</th>
                  <th className="text-center" style={{ width: '80px' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.renderTableRows()}
              </tbody>
            </Table>
          </div>
        )}

      <div style={{float: 'right'}}>
      {this.showPagination()}
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>
      </div>

       <Footer /><br/><br/>

       {/* Start of Print Payment Modal */}
       <Modal show={this.state.showPrintModal} onHide={this.handleClosePrintModal} centered>
         <Modal.Header className="d-flex align-items-center justify-content-between bg-secondary">
           <Modal.Title className="text-light font-weight-bold">Payment Details</Modal.Title>
           <div className="d-flex align-items-center">
             <button className="btn bg-success text-light font-weight-bold mb-0 me-2" onClick={() => window.print()}>
               <span className="iconify" data-icon="carbon:printer" style={{fontSize: 24}}>🖨</span> Print
             </button>
             <button type="button" className="btn btn-link m-0 p-0 text-light fs-4" onClick={this.handleClosePrintModal} aria-label="Close">
               <span className="iconify" data-icon="carbon:close">✕</span>
             </button>
           </div>
         </Modal.Header>
         <Modal.Body>
           {isPrintLoading ? (
             <center><Spinner animation="border" variant="success" size="lg" /></center>
           ) : (
             <div className="container-fluid px-4">
               {printPaymentDetails.length > 0 && printPaymentDetails.map((item, index) => (
                 <div className="row" key={index}>
                   <div className="col-12">
                     <div>
                       <center>
                         <img src={logo} className="navbar-brand-img mb-2" alt="main_logo" style={{ width: 81, marginTop: 9}} />
                         <h6>NIGERIAN COUNCIL OF FOOD SCIENCE AND TECHNOLOGY (NiCFoST)</h6>
                       </center>
                       <div className="card-body">
                         <p className="font-weight-bold">Name: {item.payer}</p>
                         <p className="font-weight-bold">RRR: {item.rrr}</p>
                         <p className="font-weight-bold">Payment Description: {`${item.description}/ ${item.formtype}`}</p>
                         <p className="font-weight-bold">Amount: &#8358;{Math.round(item.amount).toLocaleString()}</p>
                         <p className="font-weight-bold mb-4">Status: {`${item.message}`}</p>
                         <p className="text-danger">NB: Remita charges apply at the point of payment</p>
                       </div>
                     </div>
                   </div>
                 </div>
               ))}
             </div>
           )}
         </Modal.Body>
         <Modal.Footer>
           <button type="button" className="btn btn-danger" onClick={this.handleClosePrintModal}>Close</button>
         </Modal.Footer>
       </Modal>
       {/* End of Print Payment Modal */}

      </main>

      </div>
    )
  }
}

export default withSidebar(Payments);
